import styled from "styled-components";
import { Chip as ChipBUI } from "@ebscois/react-component-library";
export const NameHolder = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    &:last-child {
      padding-bottom: 0;
    }
  }

  @media print {
    padding-bottom: 0;
  }
`;

export const Pronunciation = styled.span`
  vertical-align: text-top;
`;

export const Chip = styled(ChipBUI)`
  margin-right: ${({ theme }) => theme.space.sm};
`;

export const Name = styled.div`
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  hyphens: auto;
  word-break: break-word;
  padding-right: ${({ theme }) => theme.space.md};
`;

export const LogoWrapper = styled.div`
  display: none;
  flex: 1 1 auto;
  align-items: center;
  justify-content: end;
  padding-left: 2rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
  }
`;
